/**
 * Font Lock
 * 
 * Ensures fonts are fully loaded before rendering.
 * Prevents font-induced reflow and layout shift.
 */
export async function waitForFonts(timeout = 5000) {
  // Wait for document.fonts to be ready
  if (document.fonts && document.fonts.ready) {
    try {
      await Promise.race([
        document.fonts.ready,
        new Promise(resolve => setTimeout(resolve, timeout))
      ])
      return true
    } catch {
      return false
    }
  }
  // Fallback: just wait a frame
  await new Promise(r => requestAnimationFrame(r))
  return true
}

/**
 * Load a specific font face dynamically
 */
export async function loadFontFace(family, url, options = {}) {
  if (!document.fonts) return false
  try {
    const font = new FontFace(family, `url(${url})`, {
      style: options.style || 'normal',
      weight: options.weight || '400',
      ...options,
    })
    const loaded = await font.load()
    document.fonts.add(loaded)
    return true
  } catch {
    return false
  }
}
